import React from 'react';

export default function StatusBadge(props)
{
    return <>{props.children}</>;
    
}